// © 2025 Kaitlyn Troxell
import React, { useState } from 'react';

function PageHeader({ 
  currentPage,
  onNavigate,
  currentProject,
  projects,
  onProjectChange,
  userRole,
  showPrint = false,
  onPrint = null
}) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const isAdmin = userRole === 'admin';

  const pages = [
    { id: 'calendar', name: 'Calendar', icon: '📅', adminOnly: false },
    { id: 'punchlist', name: 'Punch List', icon: '📋', adminOnly: true },
    { id: 'selections', name: 'Selections', icon: '🏠', adminOnly: false },
    //{ id: 'swornstatements', name: 'Sworn Statements', icon: '📊', adminOnly: true },
    //{ id: 'excel', name: 'Line View', icon: '📝', adminOnly: true },
    { id: 'files', name: 'Files', icon: '📁', adminOnly: false }
    
  ];

  const visiblePages = pages.filter(page => !page.adminOnly || isAdmin);

  const getPageTitle = () => {
    const page = pages.find(p => p.id === currentPage);
    return page ? `${page.icon} ${page.name}` : '📘 Project Management';
  };

  return (
    <>
      {/* Mobile Nav Overlay */}
      <div 
        className={`mobile-nav-overlay ${mobileMenuOpen ? 'active' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      />

      {/* Mobile Nav Menu */}
      <div className={`mobile-nav-menu ${mobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-nav-header">
          <h3 style={{ margin: 0 }}>Menu</h3>
          <button 
            className="mobile-nav-close"
            onClick={() => setMobileMenuOpen(false)}
          >
            ×
          </button>
        </div>
        <ul className="mobile-nav-links">
          {visiblePages.map(page => (
            <li key={page.id}>
              <button 
                className={currentPage === page.id ? 'active' : ''}
                onClick={() => {
                  onNavigate(page.id);
                  setMobileMenuOpen(false);
                }}
              >
                <span>{page.icon}</span> {page.name}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Header */}
      <header className="dashboard-page-header" style={{
        backgroundColor: '#fff',
        borderBottom: '2px solid #ddd',
        padding: '1rem 2rem',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        flexWrap: 'wrap',
        gap: '1rem'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '2rem', flex: '1 1 auto', minWidth: 0 }}>
          {/* Mobile Menu Button */}
          <button 
            className="mobile-menu-btn"
            onClick={() => setMobileMenuOpen(true)}
          >
            ☰
          </button>
          
          <h1 style={{ margin: 0, fontSize: '24px', color: '#333', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {getPageTitle()}
          </h1>
          
          {/* Desktop Navigation */}
          <nav className="desktop-nav" style={{ display: 'flex', gap: '1rem' }}>
            {visiblePages.map(page => (
              <button 
                key={page.id}
                onClick={() => onNavigate(page.id)}
                style={{
                  background: 'none',
                  border: 'none',
                  color: currentPage === page.id ? '#666' : '#007bff',
                  fontSize: '16px',
                  cursor: 'pointer',
                  textDecoration: currentPage === page.id ? 'none' : 'underline',
                  fontWeight: currentPage === page.id ? '600' : '400'
                }}
              >
                {page.name}
              </button>
            ))}
            {showPrint && onPrint && (
              <button
                onClick={onPrint}
                style={{
                  padding: '8px 16px',
                  backgroundColor: '#28a745',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  fontSize: '14px',
                  cursor: 'pointer',
                  marginLeft: '1rem'
                }}
              >
                🖨️ Print
              </button>
            )}
          </nav>
        </div>
        
        {/* Project Selector */}
        {isAdmin && (
          <div style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '1rem',
            flex: '0 1 auto',
            minWidth: 0,
            width: '100%',
            maxWidth: '300px'
          }} className="project-selector-container">
            <label htmlFor="project-select" style={{ 
              fontSize: '14px', 
              color: '#666',
              display: 'none'
            }} className="desktop-user-info">
              Project:
            </label>
            <select
              id="project-select"
              value={currentProject?.id || ''}
              onChange={(e) => {
                const selectedId = e.target.value;
                if (selectedId) {
                  onProjectChange(selectedId);
                }
              }}
              style={{
                padding: '8px 12px',
                borderRadius: '6px',
                border: '1px solid #ddd',
                fontSize: '14px',
                backgroundColor: '#fff',
                cursor: 'pointer',
                width: '100%',
                fontWeight: '500',
                color: '#333',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }}
            >
              {projects.map((project) => (
                <option key={project.id} value={project.id}>
                  {project.name}
                </option>
              ))}
            </select>
          </div>
        )}
      </header>
    </>
  );
}

export default PageHeader;